import { render, staticRenderFns } from "./LevelCard.vue?vue&type=template&id=2d6e3ddc&scoped=true&"
import script from "./LevelCard.vue?vue&type=script&lang=js&"
export * from "./LevelCard.vue?vue&type=script&lang=js&"
import style0 from "./LevelCard.vue?vue&type=style&index=0&id=2d6e3ddc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6e3ddc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardText,VCol,VDivider,VRow,VSkeletonLoader})
